import { render, staticRenderFns } from "./DraggableList.vue?vue&type=template&id=1a0d48b3&scoped=true"
import script from "./DraggableList.vue?vue&type=script&lang=js"
export * from "./DraggableList.vue?vue&type=script&lang=js"
import style0 from "./DraggableList.vue?vue&type=style&index=0&id=1a0d48b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0d48b3",
  null
  
)

export default component.exports